// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.linen",
    name: "Linen",
    homepage: "https://linen.app/",
    image_id: "aff3e4e1-92a9-4066-f48f-3591947cf200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/linen-app-investing-in-defi/id1480509067",
        android: "https://play.google.com/store/apps/details?id=app.linen.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "linen://",
        universal: "https://linen.app/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map